export enum AdminRole {
	SUPER_ADMIN = 'Super_Admin',
	MONTEL_ACCOUNT_ADMIN = 'Montel_Account_Admin',
	SALES = 'Sales',
	PRODUCT_ADMIN_MATCH = 'Product_Admin_Match',
	PRODUCT_ADMIN_NEWS_PAGE = 'Product_Admin_News_Page',
	PRODUCT_ADMIN_ALERTS = 'Product_Admin_Alerts',
	PRODUCT_ADMIN_ENAPPSYS = 'Product_Admin_EnAppSys',
	PRODUCT_ADMIN_MARKETS = 'Product_Admin_MontelMarkets',
	PRODUCT_ADMIN_EQ = 'Product_Admin_EQ',
	PRODUCT_ADMIN_SYSPOWER = 'Product_Admin_SysPower',
	PRODUCT_ADMIN_FLEXINSIGHT = 'Product_Admin_FlexInsight',
	PRODUCT_ADMIN_DATAFABRICATOR = 'Product_Admin_DataFabricator',
	PRODUCT_ADMIN_MONTELPPA = 'Product_Admin_MontelPPA',
	VIEW_ONLY = 'View_Only',
	DEVELOPER = 'Developer',
}

const adminRoleNames = {
	[AdminRole.SUPER_ADMIN]: 'Super Admin',
	[AdminRole.MONTEL_ACCOUNT_ADMIN]: 'Montel Account Admin',
	[AdminRole.SALES]: 'Sales',
	[AdminRole.VIEW_ONLY]: 'View Only',
	[AdminRole.PRODUCT_ADMIN_MATCH]: 'Product Admin - Match',
	[AdminRole.PRODUCT_ADMIN_NEWS_PAGE]: 'Product Admin - News Page',
	[AdminRole.PRODUCT_ADMIN_ALERTS]: 'Product Admin - Alerts',
	[AdminRole.PRODUCT_ADMIN_ENAPPSYS]: 'Product Admin - EnAppSys',
	[AdminRole.PRODUCT_ADMIN_MARKETS]: 'Product Admin - Montel Markets',
	[AdminRole.PRODUCT_ADMIN_EQ]: 'Product Admin - EQ',
	[AdminRole.PRODUCT_ADMIN_SYSPOWER]: 'Product Admin - SysPower',
	[AdminRole.PRODUCT_ADMIN_FLEXINSIGHT]: 'Product Admin - FlexInsight',
	[AdminRole.PRODUCT_ADMIN_DATAFABRICATOR]: 'Product Admin - Data Fabricator',
	[AdminRole.PRODUCT_ADMIN_MONTELPPA]: 'Product Admin - Montel PPA',
	[AdminRole.DEVELOPER]: 'Developer',
};

export const getAdminRoleName = (role: AdminRole) => adminRoleNames[role];

export const getAdminRoleNameFromValue = (role: string) =>
	Object.values(AdminRole).includes(role as AdminRole)
		? getAdminRoleName(role as AdminRole)
		: role;
